import { Component, EventEmitter, Input, OnInit, Output, NgModule, ChangeDetectorRef, OnDestroy, Renderer2, ElementRef } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router, ActivatedRoute } from '@angular/router';
import { OddModel } from './sports.component';
import { DataHelper } from '@helpers/data.helper';
import { environment } from '@environments/environment';
import { Location } from '@angular/common';

declare let SIR: any;

import { MatDialog } from '@angular/material/dialog';
import { HeadToHeadDialog } from './headtohead-dialog';
import { Subscription } from 'rxjs';
import { getUrlParams } from '../modules/getUrlParams';

@Component({
  selector: 'eventdetail-component',
  templateUrl: '../sharedTemplates/eventdetail.component.html',
})
export class EventDetailComponent implements OnInit, OnDestroy {
  constructor(
    private _location: Location,
    public _DataHelper: DataHelper,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    public _dataHelper: DataHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private route: ActivatedRoute,
    public _LZ: LocalizationService,
    private _changeDetection: ChangeDetectorRef,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private elementRef: ElementRef
  ) {
    this.theme = this._UiHelper.getTheme();
    this._UiHelper.changeThemeListener.subscribe((x: any) => {
      this.theme = x;
    });
    const favIndexOf = this._UiHelper.favPreMatches.indexOf(this._DataHelper.selectedMatch);

    if (favIndexOf > -1) {
      this.isFavorite = true;
    } else {
      this.isFavorite = false;
    }
  }

  SIROBJ;

  // B3000
  @Input() eventIdByInput = 0;
  isFavorite = false;
  theme = '';

  eventDetailTabItemSelected = 2;
  // B3000

  @Input() showScoreBoard = true;

  eventdetailList = [];
  event;
  enableScoreBox = true;
  _selectedOdds: OddModel[] = [];
  public lsTrackerWidget;
  public isTracerMapped = true;
  widgetEl;
  eventid = 0;

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  openLiveTrackerIsActive = false;

  ngOnInit() {
    if (this.eventIdByInput == 0) {
      this.subscriptionsToStopOnDestroy.push(
        this.route.params.subscribe(params => {
          this.eventid = params['eventid'];
          this.initialEventDetail();
        })
      );
    } else {
      this.eventid = this.eventIdByInput;
      this.initialEventDetail();
    }

    this._ApiService.getSelectedOdds();

    // this.subscriptionsToStopOnDestroy.push(

    //  this.route.queryParams.subscribe((params) => {
    //    this.returnUrl = params.returnUrl;
    //  })

    // );

    const urlParams = getUrlParams(window.location);

    console.log(urlParams);
    if (urlParams.has('odd')) {
      setTimeout(() => {
        this._ApiService.addOdd(urlParams.get('odd')).then(() => {
          this._ApiService
            .refreshCurrentSlip()
            .then()
            .catch(err => console.log('event-detail', err));
        });
      }, 1000);
    }

    this.renderLSTracker(this.eventid);
  }

  ngAfterViewInit() {
    // Scroll Top
    const elementList = document.querySelectorAll('.breadcrumb-left');
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
    // Scroll Top

    if (environment.tracker_Operator === 'LS_Tracker' && this.eventid && this.eventid !== 0) {
      setTimeout(() => {
        this.renderLSTracker();
      }, 2000);
      if (environment.product === 'cangobet') {
        this.widgetEl = this.elementRef.nativeElement.querySelector('#lsSportWrapperElemCango');
        this.element = document.getElementById('lsSportWrapperElemCango');
      }

      this.renderer.listen(this.widgetEl, 'DOMSubtreeModified', event => {
        if (this.widgetEl.innerHTML === 'Widget could not be loaded.') {
          this.isTracerMapped = false;
        }
      });
    }
  }

  initialEventDetail() {
    if (this.eventid != 0) {
      this.getEventDetails(2);
    }

    this._ApiService.selectedOddsEvent.subscribe(x => {
      this._selectedOdds = x as OddModel[];
    });

    this._UiHelper.setNavbarTitle('Sports');
  }

  getEventDetails(groupId = 2) {
    this._ApiService
      .getEvent(this.eventid)
      .then(x => {
        if (x.length > 0) {
          this.event = x[0];
        }
        try {
          if (SIR != undefined && SIR != null) {
            this.SIROBJ = SIR('addWidget', '.sr-widget-2', 'match.lmtPlus', {
              layout: 'double',
              collapseTo: 'disable',
              detailedScoreboard: 'disable',
              pitchLogo: '',
              matchId: this.event.BetradarMatchId,
            });
            this.enableScoreBox = false;
          }
        } catch (e) {
          console.log('SIR is undefined');
        }
      })
      .catch(err => console.log('eventdetail', err));

    this._ApiService
      .getEventDetails(this.eventid, groupId)
      .then(x => {
        this.eventdetailList = x;
      })
      .catch(err => console.log('eventdetail', err));
  }

  marketTypeChanged(e) {
    ////// console.log("Market Type Changed", e);
    if (e != undefined) {
      this.getEventDetails(e);
    }
  }

  clickOdd(e) {
    if (!this._dataHelper.ChangeOddIsActive && environment.submitBetModifyControl) {
      return '';
    }

    const newodd = {
      OddId: e.OddId,
    };

    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == e.OddId;
    });

    this._ApiService.addOdd(e.OddId);
  }

  checkOddId(oddId) {
    ////// console.log("oddd (2)", oddId);
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  reverse(e) {
    if (e.indexOf(':') > -1) {
      return e.split(':')[1] + ':' + e.split(':')[0];
    } else {
      return e;
    }
  }

  ToogleLiveTracker() {
    window.scroll(0, 0);
    try {
      if (!this.openLiveTrackerIsActive) {
        this.SIROBJ = SIR('updateWidget', '.sr-widget-2', {
          collapseTo: 'disable',
          pitchLogo: 'https://wettarena.de/angular/dist/assets/images/logo.png',
          matchId: this.event.BetradarMatchId,
        });
        this.openLiveTrackerIsActive = true;
      } else {
        this.SIROBJ = SIR('addWidget', '.sr-widget-2', 'match.lmtPlus', {
          layout: 'double',
          collapseTo: 'scoreboard',
          detailedScoreboard: 'disable',
          pitchLogo: 'https://wettarena.de/angular/dist/assets/images/logo.png',
          matchId: this.event.BetradarMatchId,
        });
        this.openLiveTrackerIsActive = false;
      }
    } catch (e) {
      console.log(e);
    }
  }

  eventDetailTabItemChange(tabId: number) {
    this.eventDetailTabItemSelected = tabId;

    if (tabId != undefined) {
      this.getEventDetails(tabId);
    }
  }

  goBack() {
    let iseventİd = 0;
    this.route.params.subscribe(params => {
      iseventİd = params['eventid'];
    });
    if (iseventİd != undefined && iseventİd != 0) {
      this._location.back();
    } else {
      try {
        if (SIR != undefined && SIR != null) {
          this.SIROBJ = SIR('removeWidget', '.sr-widget-2');
        }
      } catch (e) {
        console.error('event-detail', e);
      }
      this._UiHelper.b3000SetMatchDetailDialog('close');
    }
  }

  ScrollToTop() {
    const elementList = document.querySelectorAll('.breadcrumb-left');
    const element = elementList[0] as HTMLElement;
    if (element != null) {
      element.scrollIntoView({ behavior: 'smooth' });
    }

    // let scrollcord;
    // scrollcord = document.getElementById(
    //   "main-page"
    // );

    //     if (scrollcord != null) {
    //       scrollcord.scrollIntoView({
    //         behavior: "smooth",
    //         block: "start",
    //         inline: "nearest",
    //       })
    //     }
  }

  addMatch2Favs(): void {
    this.isFavorite = !this.isFavorite;
    const e = this._DataHelper.selectedMatch;

    if (e['matchfavourited'] != undefined) {
      e['matchfavourited'] = !e['matchfavourited'];
    } else {
      e['matchfavourited'] = true;
    }

    if (e['type'] != undefined && e['type'] == 'Match') {
      this._UserHelper.toogleFavoried(e['BetradarMatchId']);
    } else {
      this._UiHelper.favPreMatchChanged(e);
    }
  }

  openHeadToHeadDialog(): void {
    const dialogRef = this.dialog.open(HeadToHeadDialog, {
      maxWidth: '100%',
      width: '100%',
      height: '95%',
      maxHeight: '95%',
      panelClass: 'h2hDialogClass',
      // disableClose: true,
      data: { matchId: this.event.BetradarMatchId },
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  element;
  renderLSTracker(eventId?) {
    if (eventId == undefined) {
      eventId = this.eventid;
    }

    this.element = document.getElementById('lsSportWrapperElemCango');
    const groupId = environment.tracker_GroupId;
    const inputData = { eventId: `m:${eventId}`, language: 'en', providerId: environment.tracker_ProviderId };
    if (eventId.toString().includes('-')) {
      inputData.eventId = `m:${eventId.toString().split('-')[1]}`;
      inputData.providerId = 109;
    }
    const options = {};
    const widget = new window.STATSCOREWidgets.WidgetGroup(this.element, groupId, inputData, options);
    this.lsTrackerWidget = widget;
  }

  ngOnDestroy() {
    this.SIROBJ = null;

    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }

    // if (this._DataHelper.selectedMatchIdListener
    //   != undefined) {
    //   try {
    //     this._DataHelper.selectedMatchIdListener
    //     .unsubscribe();
    //   } catch { }
    // }
    if (this.lsTrackerWidget && this.lsTrackerWidget.destroy) {
      try {
        this.lsTrackerWidget.destroy();
      } catch (e) {
        console.log(e);
      }
    }
  }
}
